import { RightPackageTypeEnum, LoanCardTypeEnum, RightSummaryType } from '@/api/rights/types';

/** 权益服务文案映射配置 */
export interface RightsServiceConfig {
  /** 权益框架文案 */
  rightsContainerText: string;
  /** 权益描述 */
  rightsDescription: rightsDescriptionEnum;
  /** 权益价格文案类型 */
  rightsPriceText: rightsPriceTextEnum;
  /** 权益底部描述 */
  rightsBottomDescription: rightsBottomDescriptionEnum;
}

/** 权益底部描述枚举 */
export enum rightsBottomDescriptionEnum {
  /** 权益由臻有钱及权益方提供，与最终放款机构无关 */
  EQUITY_PROVIDER = 1,
  /** 权益服务由合作方提供，哈啰只负责展示 */
  CHANNEL_EQUITY = 2,
}

/** 权益描述枚举 */
export enum rightsDescriptionEnum {
  /** 自营/联营/外采/微信小程序臻享卡  哈享卡 */
  SELF_ZHENXIANG_CARD = 1,
  /** 渠道臻享卡 */
  CHANNEL_ZHENXIANG_CARD = 2,
  /** 臻享会员卡 */
  ZHENXIANG_MEMBER_CARD = 3,
}

export enum rightsPriceTextEnum {
  /** 臻享卡 */
  ZHENXIANG_CARD = 1,
  /** 臻享会员卡 */
  ZHENXIANG_MEMBER_CARD = 2,
}

/** 权益服务文案映射类 */
export class RightsServiceMapping {
  /** 权益服务文案映射表 */
  private readonly rightsServiceMap: Record<string, RightsServiceConfig> = {
    zhenxiangMemberCard: {
      // packageType = 9 时显示臻享会员服务
      rightsContainerText: '臻享会员服务',
      // packageType = 9 时显示臻享会员卡描述
      rightsDescription: rightsDescriptionEnum.ZHENXIANG_MEMBER_CARD,
      // packageType = 9 时显示臻享会员卡价格文案
      rightsPriceText: rightsPriceTextEnum.ZHENXIANG_MEMBER_CARD,
      // packageType = 9 时显示权益底部描述
      rightsBottomDescription: rightsBottomDescriptionEnum.EQUITY_PROVIDER,
    },
    unionCard: {
      // loanCardType = 1,2,3 自营/联营/外采/微信小程序
      rightsContainerText: '臻有钱定制服务',
      // loanCardType = 1,2,3 自营/联营/外采/微信小程序臻享卡描述  哈享卡描述
      rightsDescription: rightsDescriptionEnum.SELF_ZHENXIANG_CARD,
      // loanCardType = 1,2,3 自营/联营/外采/微信小程序臻享卡价格文案
      rightsPriceText: rightsPriceTextEnum.ZHENXIANG_CARD,
      // loanCardType = 1,2,3 自营/联营/外采/微信小程序臻享卡底部描述
      rightsBottomDescription: rightsBottomDescriptionEnum.EQUITY_PROVIDER,
    },
    haxiangCard: {
      // loanCardType = 4 哈享卡
      rightsContainerText: '优享服务',
      // loanCardType = 4 自营/联营/外采/微信小程序臻享卡描述  哈享卡描述
      rightsDescription: rightsDescriptionEnum.SELF_ZHENXIANG_CARD,
      // loanCardType = 4 哈享卡价格文案
      rightsPriceText: rightsPriceTextEnum.ZHENXIANG_CARD,
      // loanCardType = 4 哈享卡底部描述
      rightsBottomDescription: rightsBottomDescriptionEnum.EQUITY_PROVIDER,
    },
    channelRightCard: {
      // loanCardType = 5 渠道权益
      rightsContainerText: '专属服务',
      // loanCardType = 5 渠道权益描述
      rightsDescription: rightsDescriptionEnum.CHANNEL_ZHENXIANG_CARD,
      // loanCardType = 5 渠道权益价格文案
      rightsPriceText: rightsPriceTextEnum.ZHENXIANG_CARD,
      // loanCardType = 5 渠道权益底部描述
      rightsBottomDescription: rightsBottomDescriptionEnum.CHANNEL_EQUITY,
    },
  };

  /**
   * 根据 rightSummary 获取当前权益服务文案
   * @param rightSummary 权益概述数据
   * @returns 权益服务文案配置
   */
  public getRightsServiceText(rightSummary?: RightSummaryType): RightsServiceConfig {
    const { packageType, loanCardType } = rightSummary || {};

    // packageType = 9 的优先级最高
    if (packageType === RightPackageTypeEnum.ZHEN_XIANG_MEMBER_CARD) {
      return this.rightsServiceMap.zhenxiangMemberCard;
    }

    // packageType = 4 时根据 loanCardType 区分
    if (packageType === RightPackageTypeEnum.CHANNEL_B) {
      if (loanCardType === LoanCardTypeEnum.CHANNEL_B
          || loanCardType === LoanCardTypeEnum.JOINT_VENTURE
          || loanCardType === LoanCardTypeEnum.OUT_FLOW) {
        return this.rightsServiceMap.unionCard;
      }

      if (loanCardType === LoanCardTypeEnum.YOU_SU_CARD) {
        return this.rightsServiceMap.haxiangCard;
      }

      if (loanCardType === LoanCardTypeEnum.CHANNEL_RIGHT) {
        return this.rightsServiceMap.channelRightCard;
      }
    }

    // 默认返回
    return this.rightsServiceMap.unionCard;
  }
}

/** 权益服务文案映射实例（单例模式） */
export const rightsServiceMapping = new RightsServiceMapping();
